/**
 * @file shape-usage.ts
 * @description «Где: …» у групп вкладки «Оформление → Кнопки и карточки»
 * (phase19.16; замечание владельца 2026-10-11 «не понятно, на что влияет»;
 * по образцу строк «Где:» вкладки «Шрифты» и реестра `FONT_ROLES`).
 *
 * Пока тексты нужны только кабинету, они лежат здесь, а не в
 * `@chaiberi/shared` (shared в эти дни дорабатывается параллельно). Когда
 * понадобятся подсказкам в панелях элементов — перенести рядом с
 * `FONT_ROLES` одним источником.
 */

/** Охват «Карточек и фото» по частям: чьи карточки и что ещё (одна строка на оба случая SB31). */
const CARDS_OF = ["товаров", "статей"] as const;
const CARDS_ALSO = "плитки «фото сверху», отзывы, карточки цифр и таблиц, фото в секциях";
/** «карточки товаров, статей, …» — из частей. */
function cardsUsage(of: readonly string[]): string {
  return `карточки ${of.join(", ")}, ${CARDS_ALSO}`;
}

/** Группы и настройки вкладки, у которых есть строка «Где». */
export type ShapeUsageKey = "buttons" | "buttonArrow" | "buttonCase" | "cards" | "spacing";

/** Строка «Где: …» (со строчной буквы — после «Где:»). */
export const SHAPE_USAGE: Readonly<Record<ShapeUsageKey, string>> = {
  buttons: "все кнопки сайта — в секциях, в карточке товара, в корзине и при оформлении заказа",
  buttonArrow: "в кнопках-ссылках секций",
  buttonCase: "подписи всех кнопок",
  cards: cardsUsage(CARDS_OF),
  spacing: "отступы между блоками и внутри секций, подвал",
};

/**
 * «Карточки и фото», когда у карточки товара в каталоге свой вид (SB31,
 * решение 2026-10-12): карточек товаров в охвате нет — они заданы в «Каталоге».
 */
export const CARDS_USAGE_EXCEPT_PRODUCTS = cardsUsage(CARDS_OF.filter((of) => of !== "товаров"));

/** Строка «Где» группы «Карточки и фото» с учётом своей карточки товара. */
export function cardsUsageText(ownProductCards: boolean): string {
  return ownProductCards ? `Где: ${CARDS_USAGE_EXCEPT_PRODUCTS}` : shapeUsageText("cards");
}

/** «Где: …» для группы. */
export function shapeUsageText(key: ShapeUsageKey): string {
  return `Где: ${SHAPE_USAGE[key]}`;
}
